module.exports = __webpack_public_path__ + "static/img/code.5dd52f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code.jpg
// module id = d46q
// module chunks = 15